document.addEventListener("DOMContentLoaded", function () {
  console.log(window.firstCartItem);
  const productRecommendationsSection = document.querySelector(
    ".product-recommendations"
  );



  fetch(
    window.Shopify.routes.root +
      "recommendations/products?product_id="+window.firstCartItem+"&limit=4&section_id=product-recommendations&intent=related"
  )
    .then((response) => response.text())
    .then((data) => {
      productRecommendationsSection.innerHTML = data;
    });
});
